import { Project } from "@iventis/domain-model/model/project";
import { Sitemap } from "@iventis/domain-model/model/sitemap";

type SetSubmittingAction = { type: "set-submitting"; payload: boolean };
type SetAvailableProjectsAction = { type: "set-available-projects"; payload: Project[] };
type SetSelectedProjectAction = { type: "set-selected-project"; payload: Project | null };
type SetSitemapsAction = { type: "set-sitemaps"; payload: Sitemap[] };
type SetLoadingSitemapsAction = { type: "set-loading-sitemaps"; payload: boolean };
type SetSelectedSitemapAction = { type: "set-selected-sitemap"; payload: Sitemap | null };
type SetProjectQueryAction = { type: "set-project-query"; payload: string };
type SetSearchingProjectsAction = { type: "set-searching-projects"; payload: boolean };
type ResetProjectSelectionAction = { type: "reset-project-selection" };

type SitemapVersionCopyAction =
    | SetSubmittingAction
    | SetAvailableProjectsAction
    | SetSelectedProjectAction
    | SetSitemapsAction
    | SetLoadingSitemapsAction
    | SetSelectedSitemapAction
    | SetProjectQueryAction
    | SetSearchingProjectsAction
    | ResetProjectSelectionAction;

export type SitemapVersionCopyState = {
    isSubmitting: boolean;
    availableProjects: Project[];
    selectedProject: Project | null;
    sitemaps: Sitemap[];
    isLoadingSitemaps: boolean;
    selectedSitemap: Sitemap | null;
    projectQuery: string;
    isSearchingProjects: boolean;
};

export const initialSitemapVersionCopyState: SitemapVersionCopyState = {
    isSubmitting: false,
    availableProjects: [],
    selectedProject: null,
    sitemaps: [],
    isLoadingSitemaps: false,
    selectedSitemap: null,
    projectQuery: "",
    isSearchingProjects: false,
};

export function sitemapVersionCopyReducer(state: SitemapVersionCopyState, action: SitemapVersionCopyAction): SitemapVersionCopyState {
    switch (action.type) {
        case "set-submitting":
            return {
                ...state,
                isSubmitting: action.payload,
            };
        case "set-available-projects":
            return {
                ...state,
                availableProjects: action.payload,
            };
        case "set-selected-project":
            return {
                ...state,
                selectedProject: action.payload,
            };
        case "set-sitemaps":
            return {
                ...state,
                sitemaps: action.payload,
            };
        case "set-loading-sitemaps":
            return {
                ...state,
                isLoadingSitemaps: action.payload,
            };
        case "set-selected-sitemap":
            return {
                ...state,
                selectedSitemap: action.payload,
            };
        case "set-project-query":
            return {
                ...state,
                projectQuery: action.payload,
            };
        case "set-searching-projects":
            return {
                ...state,
                isSearchingProjects: action.payload,
            };
        case "reset-project-selection":
            return {
                ...state,
                selectedProject: null,
                selectedSitemap: null,
                sitemaps: [],
            };
        default: {
            // Exhaustive type checking - will cause compile-time error if action type is not handled
            const _exhaustiveCheck: never = action;
            throw new Error(`Unhandled action type: ${_exhaustiveCheck}`);
        }
    }
}
